export default __webpack_public_path__ + "static/media/img49.5b56aae6.jpg";